export const getPreviewURL = (brand: string, experienceId) =>
  `${window.configs[`${brand.toUpperCase()}_CUSTOMER_PORTAL`]}/experience/preview/${experienceId}`;
